import IAppState from "./IAppState";

import {combineReducers} from "redux";
import {Alert} from "react-native";
import ClientReducers from "../Client/ClientReducers";
import CourierReducers from "../Courier/CourierReducers";
import UserReducers from "../User/UserReducers";


const defualtState:IAppState={
    client:{clients:[]},
    courier:{couriers:[],openedOrders:[],orderHistory:[]},
    user:{current:undefined},


}
function createReducer(initialState:any, handlers:any) {
    return function reducer(state = initialState, action:any) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action)
        } else {
            return state
        }
    }
}

const clientReducers = createReducer(defualtState.client, ClientReducers)
const courierReducers = createReducer(defualtState.courier, CourierReducers)
const userReducers = createReducer(defualtState.user, UserReducers)

const appReducer = combineReducers({
    client: clientReducers,
    courier:courierReducers,
    user:userReducers
})

export default appReducer
